import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import SpecialsScreen from './specials';

function Index({ dishs, setShowListProduct, goHome }) {
  const { i18n } = useTranslation();
  const langEng = i18n.language === 'en' ?? false;

  const { menus, name: title } = dishs;

  const [showSpecials, setShowSpecials] = useState(false);

  const [titleCategorie, setIitleCategorie] = useState('');

  const [showDetailProduct, setShowDetailProduct] = useState(false);
  const [dataDish, setDataDish] = useState(false);

  useEffect(() => {
    if (menus) {
      setIitleCategorie(
        langEng
          ? dishs.name
          : translate(i18n.language, dishs.language, dishs.name),
      );
    }
  }, [menus]);

  const fetchImage = async (id) => {
    const imageBlob = await getImage(id);
    if (imageBlob) {
      const imageURL = URL.createObjectURL(imageBlob.data.blob);
      return imageURL;
    }
    return null;
  };

  const Item = ({ data }) => {
    const [image, setImage] = useState(false);
    useEffect(() => {
      fetchImage(`menu-image-${data.id}`).then((url) => {
        if (url) {
          setImage(url);
        }
      });
    }, []);

    return (
      <div
        onClick={() => [
          setShowDetailProduct(true),
          setDataDish({ dish: data, alldish: menus, currentDish: dishs }),
        ]}
        style={{
          backgroundColor: 'black',
          marginBottom: 30,
          textDecoration: 'none',
          width: 330,
          maxHeight: 410,
          margin: '15px 0px',
          textAlign: 'left',
          paddingTop: 10,
          paddingBottom: 20,
          paddingInline: 15,
          boxSizing: 'border-box',
          position: 'relative',
          borderRadius: 30,
        }}
      >
        <img
          src={image}
          style={{
            width: '100%',
            height: 280,
            objectFit: 'cover',
            borderRadius: 20,
          }}
        />
        <h3
          style={{
            fontWeight: '900',
            color: '#fff',
            textTransform: 'uppercase',
            fontSize: 22,
            margin: 0,
            textAlign: 'center',
          }}
        >
          {' '}
          {langEng
            ? data.name
            : translate(i18n.language, data.language, data.name)}
        </h3>

        <div style={{ width: '80%', margin: '0 auto' }}>
          <p
            className="shor-text-one"
            style={{
              fontFamily: 'LondrinaSolidLight',
              fontSize: 15,
              color: '#fff',
              textAlign: 'center',
              margin: 0,
            }}
          >
            {langEng
              ? `${data.regular_decription.replace(/\\n/g, '\n')}`
              : `${translateMenu(
                  i18n.language,
                  data.language,
                  data.regular_decription,
                  'regular_decription',
                )}`}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: 4,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
      }}
    >
      <LayoutContent
        showBack={true}
        goHome={goHome}
        setShowListProduct={setShowListProduct}
        setShowSpecials={setShowSpecials}
      >
        <div>
          <div
            style={{
              width: '70%',
              marginTop: 20,
              marginBottom: 20,
              margin: '0 auto',
              border: '5px solid #ED3E08',
              display: 'flex',
              alignSelf: 'center',
              justifyContent: 'center',
              alignItems: 'center',
              paddingBlock: 5,
              position: 'relative',
            }}
          >
            <div>
              <p
                style={{
                  fontFamily: 'Watchtower',
                  fontSize: 60,
                  color: '#ED3E08',
                  margin: 0,
                }}
              >
                {titleCategorie}
              </p>
              {(dishs.id === 614 || dishs.id === 615) && (
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 25,
                    color: '#fff',
                    margin: 0,
                  }}
                >
                  Choose a Flavor for $1 Extra: <br /> Passion Fruit - Mango -
                  Coconut - Strawberry
                </p>
              )}
            </div>
            <img
              src={require('./assets/OBJECTS2.png')}
              style={{
                width: 60,
                height: 60,
                objectFit: 'contain',
                position: 'absolute',
                right: -80,
              }}
            />
          </div>

          <div
            style={{
              marginTop: 20,
              background: '#EBEBEB',
              borderRadius: 30,
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-between',
              padding: '0px 20px 100px 20px',
              height: 570,
              overflow: 'scroll',
            }}
          >
            {menus.map((item, key) => (
              <Item data={item} key={key} />
            ))}
          </div>
        </div>
        {showDetailProduct && (
          <DetailProduct
            dishMenu={dataDish}
            setShowListProduct2={setShowListProduct}
            setShowDetailProduct={setShowDetailProduct}
          />
        )}

        {showSpecials && (
          <SpecialsScreen
            setShowListProduct={setShowSpecials}
            setShowHappy={setShowListProduct}
          />
        )}
      </LayoutContent>
    </div>
  );
}
export default Index;
